module.exports = __webpack_public_path__ + "img/billpay.ae6c37cb.png";